<template>

  <div id="app">

<link rel="preconnect" href="https://fonts.gstatic.com">
<link href="https://fonts.googleapis.com/css2?family=Kanit&display=swap" rel="stylesheet">

    <v-overlay :value="isLoading" key="overlay-loading" :z-index="999999999">
      <v-progress-circular
        indeterminate
        color="red"
      ></v-progress-circular>
    </v-overlay>
    <router-view/>

  </div>
</template>

<script>
import config from '../config.js'

  export default {
    metaInfo : {
      title: config.title
    },
    data () {
      return {
        loading:  this.$store.state.is_loading,
      }
    },
    computed: {
      isLoading: function() {
        return this.$store.state.is_loading;
      }
    }
  }
</script>

<style lang="scss">
#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
